import { render, staticRenderFns } from "./SolicitudVer.vue?vue&type=template&id=117b5cb2"
import script from "./SolicitudVer.vue?vue&type=script&lang=js"
export * from "./SolicitudVer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports